import React from 'react';

export default function Telegram() {
    return (
        <a
            href="https://t.me/fghofficialactivitygroup"
            target="_blank"
            rel="noopener noreferrer"
            className="telegram"
        >
            <div className="telegram--logo">
                <img
                    src="/images/icon/social-media/telegram.webp"
                    alt="Telegram"
                />
            </div>

            <div className="telegram--text">Join Our Telegram</div>
        </a>
    );
}
